import { useQuery } from '@tanstack/react-query';
import { userPanelApi } from 'api';
import { usePanel } from 'contexts/panelContext';
import { usePair } from 'contexts/pairContext';

export const useCounterpartApplication = (enabled = true) => {
	const { currentApplicationData, currentProgramMembership } = usePanel();

	const pair = usePair();
	const pairId = Number(pair?.pair?.id);

	return useQuery(
		[
			'get-pair-application-details',
			{
				membershipId: currentProgramMembership?.id,
				applicationRole: currentApplicationData?.applicationRole,
				pairId,
			},
		],
		() =>
			userPanelApi.getPairApplicationDetails(
				currentApplicationData?.applicationRole,
				currentProgramMembership?.id,
				pairId
			),
		{ enabled: enabled && Boolean(pairId) }
	);
};
